import { UserFilterFormData } from '@modules/battlePlan/BattlePlanPage/BattlePlanPage';
import { Endpoint } from '../endpoint';
import { BattlePlanSectionResponse, SectionId } from '@business/entities/battle_plan';
import { R } from '@core/utils/r';
import { CompactUserResponse } from '@business/entities/account';

export function fetchBattlePlanSection(data?: UserFilterFormData) {
  const params = R.objectCompact(data);
  return Endpoint.get<BattlePlanSectionResponse[]>(`@makh/battle-plan-sections`, { params });
}

export function createBattlePlanSection(data: Partial<BattlePlanSectionResponse>) {
  return Endpoint.post<BattlePlanSectionResponse>(`@makh/battle-plan-sections`, { data });
}

export function deleteBattlePlanSection(id: SectionId) {
  return Endpoint.delete<void>(`@makh/battle-plan-sections/${id}`);
}

export function selectOneSection(sectionId: SectionId) {
  return Endpoint.get<BattlePlanSectionResponse>(`@makh/battle-plan-sections/battle-plan-section/${sectionId}`);
}

export function updateBattlePlanSection(sectionId: SectionId, data: Partial<BattlePlanSectionResponse>) {
  return Endpoint.patch<BattlePlanSectionResponse>(`@makh/battle-plan-sections/${sectionId}`, { data });
}

export function sortBattlePlanSection(section: BattlePlanSectionResponse, fromPosition: any, toPosition: number) {
  return Endpoint.post<BattlePlanSectionResponse[]>(`@makh/battle-plan-sections/sort-battle-plan-sections`, {
    data: { section, fromPosition, toPosition },
  });
}

export function fetchUsers() {
  return Endpoint.get<CompactUserResponse[]>(`@makh/battle-plan-sections/users`);
}
